import React, { useContext, useState } from 'react';
import PropTypes from 'prop-types';
import classnames from 'classnames';
import { useMedia } from 'react-use';
import { Button, Icon } from 'ck-ui';
import { addMultipleToCart } from 'ck-utils';
import { BundleLookPageContext } from '../context';
import styles from './AddBundleToCart.module.scss';

const AddBundleToCart = ({ isModal, onComplete }) => {
  const [loading, setLoading] = useState(false);
  const { groups, bundle = {}, addedCount } = useContext(BundleLookPageContext);
  const isMobile = useMedia('(max-width: 767px)');
  const size = isModal || !isMobile ? 'large' : null;

  const addToCart = async () => {
    const items = groups.reduce((acc, group) => [
      ...acc,
      ...group.products.map(product => ({ id: product.variantId, quantity: 1 }))
    ], []);

    setLoading(true);
    await addMultipleToCart(items);
    setLoading(false);
    if (isModal && onComplete) onComplete();
  };

  return (
    <Button
      prefix={<Icon name="cart" />}
      color="success-dark"
      onClick={addToCart}
      loading={loading}
      size={size}
      disabled={bundle.totalCount !== addedCount}
      fullwidth="mobile"
      className={classnames({
        [styles.addToCart]: !isModal,
        [styles.btnMarginTop]: isModal
      })}
    >
      {isMobile ? 'ADD TO CART' : 'ADD BUNDLE TO CART'}
    </Button>
  );
};

AddBundleToCart.propTypes = {
  isModal: PropTypes.bool,
  onComplete: PropTypes.func
};

AddBundleToCart.defaultProps = {
  isModal: false,
  onComplete: null
};

export { AddBundleToCart };
